import { Outlet } from "react-router-dom";

const MasterPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default MasterPageLayout;